import TaskItem from "./TaskItem";

function TaskList({ tasks, onDelete }) {
  return (
    <ul>
      {tasks.map((task) => (
        <TaskItem
          key={task._id}
          task={task}
          onDelete={onDelete}
        />
      ))}
    </ul>
  );
}

export default TaskList;